import script from "./ChiTietXuatTheoDoiTuongTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChiTietXuatTheoDoiTuongTable.vue?vue&type=script&lang=ts&setup=true"

import "./ChiTietXuatTheoDoiTuongTable.vue?vue&type=style&index=0&id=4d5acfc8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5acfc8"]])

export default __exports__